var ctPermissionModel;
(function ($) {
 	$.fn.capitechPermissions = function(options) {
		var $ctPermissionsElm = $(this);
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			var modelData = getLocalStorage('myCapitechPermissionsAndRegistrationSetup');
			ctPermissionModel = ko.viewmodel.fromModel(modelData);
			
			$('*[data-ko-bind="ctPermissionModel"]').each(function(index, obj) {
				ko.applyBindings(ctPermissionModel,obj);
			});
		}
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));